import SettingsItem from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsItem";
import SettingsItemText from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsItemText";
import SettingsSection from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsSection";
import { useEditor, useNode } from "@craftjs/core";
import { Grid } from "@mui/material";

const Settings = () => {
    const { id } = useNode();
    const { displayName, actions } = useEditor((state) => ({
        displayName:
            state.nodes[id] && state.nodes[id].data.custom.displayName
                ? state.nodes[id].data.custom.displayName
                : state.nodes[id].data.displayName,
    }));

    return (
        <>
            <SettingsSection
                title="Identification"
                summary={() => {
                    return `${displayName || "-"}`;
                }}
            >
                <Grid size={{ xs: 12 }}>
                    <SettingsItemText
                        type={"text"}
                        value={displayName}
                        onChange={(value: string) => {
                            actions.setCustom(id, (custom) => (custom.displayName = value));
                        }}
                        fullWidth={true}
                        label="Display name"
                    />
                </Grid>
            </SettingsSection>
            <SettingsSection
                title="Appearance"
                props={["columns"]}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                summary={({ columns }: any) => {
                    return `` + (columns ? `Columns: ${columns}` : "No columns set");
                }}
            >
                <SettingsItem fullWidth propKey="columns" index={0} type="slider" min={0} max={5} label="Columns" />
                <SettingsItem
                    fullWidth
                    propKey="rowGap"
                    index={0}
                    type="slider"
                    min={0}
                    max={5}
                    label="Space between rows"
                />
                <SettingsItem
                    fullWidth
                    propKey="columnGap"
                    index={0}
                    type="slider"
                    min={0}
                    max={5}
                    label="Space between columns"
                />
            </SettingsSection>
        </>
    );
};

export default Settings;
